<card>
    <div class="card-header-content">
        <span *ngIf="tnrList.length < 2"> {{ wording.tnr }}</span>
        <span *ngIf="tnrList.length > 1"> {{ wording.tnrs }}</span>
    </div>
    <div class="card-body-content">
        <div *ngFor="let tnr of tnrList; let i = index">
            <list-select type="travellersynchronyme"
                         [list]="tnr.traveller"
                         [listId]="getBookingId(tnr)"
                         selectedIf="journey" disabledIf="journey"
                         (showItemEvent)="showPnr($event)">
                <span class="list-header">
                  {{getBookingId(tnr)}}<journey [data]="tnr.journey"></journey>
                  <btn type="actionUndo"
                       (click)="removeTnrList(i)"
                       click-stop>
                      <span class="icon">
                          <fa-icon [icon]="iconTimes"></fa-icon>
                      </span>
                  </btn>
                </span>
                <!-- TODO : list-header-content -->
                <!-- TODO : list-header-action -->
            </list-select>

        </div>

    </div>
    <div class="card-footer-content colored">
        <btn type="actionDo"
             [label]="Yii.t( 'wui-skn-js', 'Ajouter un Dossier' )"
             *ngIf="!f_showForm && canAddReferencePermission"
             (click)="f_showForm = true; inputTnr = ''">
        <span class="icon">
            <fa-icon [icon]="iconPlus"></fa-icon>
        </span>
        </btn>
        <ng-container *ngIf="f_showForm">
            <form (submit)="getTnrList(inputTnr)">
                <input type="text"
                       [(ngModel)]="inputTnr"
                       name="inputTnr"
                       [placeholder]="Yii.t( 'wui-skn-js', 'Saisir un n° de Dossier' )"
                       autofocus required
                       class="inPlace">
                <btn type="actionDo" label="OK" btnType="submit" [disableIf]="inputTnr.length < 1"></btn>
                <btn type="actionUndo"
                     [label]="Yii.t( 'wui-skn-js', 'Annuler' )"
                     (click)="f_showForm = false"></btn>
            </form>
        </ng-container>
        <notification *ngIf="tnrError" type="error" [showCloseButton]="true" (onClose)="tnrError=false">
            {{ tnrErrorMessage }}
        </notification>
        <loader *ngIf="tnrPending" [message]="apiLabels.pending"></loader>

    </div>
</card>
